import { ActionBar, ChakraBox, FAIconName } from '@equip.health/ui';
import { AISummaryEvents } from '~/analytics/aiSummaryEvents';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

export const AI_SUMMARY_HELP_LINK =
  'https://equip-health--simpplr.vf.force.com/apex/simpplr__app?u=/site/a14Ua000001td6bIAA/page/a12Ua000002IqQPIA0';

export const PatientNoteAiSummaryErrorBanner = () => {
  const { trackEvent } = useAnalytics();

  function openHelpLink(): void {
    trackEvent(AISummaryEvents.aiSummaryLearnMoreLinkClicked, {
      Source: AnalyticsSourceValues.SESSION_GUIDE,
    });
    window.open(AI_SUMMARY_HELP_LINK, '_blank', 'noopener');
  }
  return (
    <ChakraBox marginY="12px">
      <ActionBar
        barIcon={FAIconName.exclamationCircleRegular}
        buttonIcon={FAIconName.externalLinkRegular}
        buttonText="Learn more"
        id="patient-note-ai-summary-error-banner"
        onButtonClick={() => openHelpLink()}
        text="AI summary is not available for this session"
        variant="warning"
      />
    </ChakraBox>
  );
};
